export default function Gallery() {
  const images = [
    {
      url: 'https://public.readdy.ai/ai/img_res/e6bc9cbbb0062230ce125474671fd62b.jpg',
      title: 'Treatment Room',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=professional%20aesthetic%20doctor%20performing%20facial%20treatment%20on%20client%20in%20luxury%20clinic%20modern%20medical%20procedure%20elegant%20treatment%20space%20with%20advanced%20equipment%20premium%20beauty%20service&width=600&height=800&seq=gallery002&orientation=portrait',
      title: 'Expert Care',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=elegant%20aesthetic%20clinic%20reception%20area%20with%20luxurious%20interior%20design%20modern%20waiting%20room%20sophisticated%20decor%20premium%20medical%20spa%20entrance%20with%20refined%20atmosphere&width=800&height=600&seq=gallery003&orientation=landscape',
      title: 'Reception Area',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=advanced%20laser%20treatment%20equipment%20in%20modern%20aesthetic%20clinic%20high-tech%20medical%20devices%20professional%20beauty%20technology%20sophisticated%20treatment%20tools%20in%20luxury%20spa%20setting&width=600&height=800&seq=gallery004&orientation=portrait',
      title: 'Advanced Technology',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=relaxing%20consultation%20room%20in%20luxury%20aesthetic%20clinic%20comfortable%20seating%20elegant%20interior%20design%20premium%20medical%20spa%20consultation%20space%20with%20natural%20lighting&width=800&height=600&seq=gallery005&orientation=landscape',
      title: 'Consultation Space',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=premium%20skincare%20products%20display%20in%20aesthetic%20clinic%20luxury%20beauty%20products%20elegant%20product%20showcase%20sophisticated%20retail%20area%20in%20medical%20spa&width=600&height=800&seq=gallery006&orientation=portrait',
      title: 'Premium Products',
    },
  ];

  return (
    <section id="gallery" className="py-24 bg-gradient-to-b from-white via-esthe-vanilla-creme/30 to-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <p className="text-esthe-light-bronze text-sm tracking-widest uppercase mb-4 font-medium">
            / OUR SPACE
          </p>
          <h2 className="text-5xl font-serif mb-6 text-esthe-cafe-noir">
            Experience Luxury
          </h2>
          <p className="text-lg text-esthe-mocha max-w-2xl mx-auto">
            Step into our state-of-the-art facility designed for your comfort and privacy
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 aspect-square cursor-pointer"
            >
              <div className="w-full h-full">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-esthe-mocha/80 via-esthe-light-bronze/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                <h3 className="text-white text-xl font-serif">{image.title}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <a
            href="#contact"
            className="inline-block px-10 py-4 bg-gradient-to-r from-esthe-pale-taupe to-esthe-light-bronze text-white rounded-full text-base font-medium hover:from-esthe-light-bronze hover:to-esthe-mocha transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            Schedule a Tour
          </a>
        </div>
      </div>
    </section>
  );
}
